import usePageMeta from '@/hooks/usePageMeta';
import HeroSection from './components/HeroSection';
import StatsSection from './components/StatsSection';
import CategorySection from './components/CategorySection';
import FeaturedSection from './components/FeaturedSection';
import LatestSection from './components/LatestSection';

export default function Home() {
  const organizationSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '番号吧',
    url: 'https://fanhaoba.com',
    description: '专业番号查询与影片信息平台',
    email: 'contact@fanhaoba.com',
  };

  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '番号吧',
    url: 'https://fanhaoba.com',
    potentialAction: {
      '@type': 'SearchAction',
      'query-input': 'required name=search_term',
      target: {
        '@type': 'EntryPoint',
        urlTemplate: 'https://fanhaoba.com/category/all?search={search_term}',
      },
    },
  };

  const webpageSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '番号吧 - 专业番号查询与影片信息平台',
    description: '番号吧是专业的番号查询平台，提供海量番号信息检索、影片详情、演员资料及分类浏览服务。',
    url: 'https://fanhaoba.com/',
    isPartOf: {
      '@type': 'WebSite',
      name: '番号吧',
    },
  };

  usePageMeta({
    title: '番号吧 - 专业番号查询与影片信息平台',
    description: '番号吧是专业的番号查询平台，提供海量番号信息检索、影片详情、演员资料及分类浏览服务。无论你在寻找特定番号还是探索新内容，番号吧都能帮你快速精准找到所需信息。',
    keywords: '番号吧,番号查询,番号搜索,番号大全,日本番号,番号库,影片番号检索',
    canonicalUrl: 'https://fanhaoba.com/',
    ogTitle: '番号吧 - 专业番号查询与影片信息平台',
    ogDescription: '番号吧是专业的番号查询平台，提供海量番号信息检索、影片详情、演员资料及分类浏览服务。',
    ogType: 'website',
    ogUrl: 'https://fanhaoba.com/',
    jsonLd: [organizationSchema, websiteSchema, webpageSchema],
  });

  return (
    <main>
      <HeroSection />
      <StatsSection />
      <CategorySection />
      <FeaturedSection />
      <LatestSection />
    </main>
  );
}